import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { StandardText } from "./standard";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";

const useStyles = () => {
  const theme = useTheme();
  return makeStyles({
    root: {
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
        padding: 20,
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    paper: {
      margin: theme.spacing(1),
      width: 350,
    },
    margin: {
      //margin: theme.spacing(1),
      //marginBottom: theme.spacing(1),
      //width: 300,
    },
    grid_margin: {
      marginTop: theme.spacing(1),
    },
    field_1: {},
  });
};

export const FieldSelector = ({
  xs,
  sm,
  md,
  lg,
  label,
  options,
  forwardRef,
  onChange,
  textSize,
  extraItem,
  innerRef,
  ...other
}) => {
  const classes = useStyles();
  //ok

  const ref = useRef();

  return (
    <Grid size={{ lg, md, sm, xs }}>
      <FormControl
        variant="outlined"
        fullWidth
        size="small"
        className={classes.margin}
      >
        <InputLabel id={label + "-label"}>{label}</InputLabel>
        <Select
          ref={ref}
          inputRef={(ref) => forwardRef && forwardRef(ref)}
          labelId={label + "-label"}
          id={label}
          //value={value}
          //defaultValue={""}

          onChange={(e) => {
            // const obj = e.target.value;
            // const { value } = obj;

            // e.target.value = value;

            return onChange && onChange(e);
          }}
          label={label}
          {...other}
          inputProps={{ size: "small" }}
        >
          <MenuItem disabled value="">
            <em>Selecione</em>
          </MenuItem>
          {options.map((v, k) => (
            <MenuItem key={k} value={v.value}>
              <StandardText
                size={textSize || 12}
                startIcon={
                  <Icon style={{ color: "gray", fontSize: 20 }}>
                    {v.icon || "chevron_right"}
                  </Icon>
                }
              >
                {v.label}
              </StandardText>
            </MenuItem>
          ))}
          {extraItem || null}
        </Select>
      </FormControl>
    </Grid>
  );
};

export const FieldText = (props) => {
  const {
    xs,
    sm,
    md,
    lg,
    value,
    defaultValue,
    label,
    type,
    keyboard,
    onChange,
    forwardRef,
    placeholder,
    helper,
    passwordIcon,
    ...other
  } = props;

  const classes = useStyles();

  const [showPassword, handleShowPassword] = useState(false);

  return (
    <Grid size={{ lg, md, sm, xs }}>
      <FormControl
        size="small"
        className={classes.margin}
        fullWidth
        variant="outlined"
      >
        <InputLabel
          sx={{
            zIndex: 0,
          }}
          htmlFor={label}
        >
          {label}
        </InputLabel>
        <OutlinedInput autoFocus
          inputRef={(ref) => forwardRef && forwardRef(ref)}
          onChange={onChange}
          label={label}
          id={label}
          defaultValue={defaultValue}
          type={
            passwordIcon ? (showPassword ? "text" : "password") : type || "text"
          }
          value={value}
          placeholder={placeholder}
          //onChange={handleChange("name")}

          size="small"
          //labelWidth={(label || "").length * 10}
          inputProps={{
            size: "small",
            min: other.min,
            max: other.max,

            inputMode: keyboard || "text",
          }}
          endAdornment={
            passwordIcon && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => handleShowPassword((s) => !s)}
                  edge="end"
                >
                  <Icon>{showPassword ? "visibility" : "visibility_off"}</Icon>
                </IconButton>
              </InputAdornment>
            )
          }
          {...other}
        />
      </FormControl>
      <StandardText size={12} light={1}>
        {helper}
      </StandardText>
    </Grid>
  );
};

export const FieldSwitch = (props) => {
  const {
    xs,
    sm,
    md,
    lg,
    value,
    checked,
    defaultValue,
    label,
    type,
    onChange,
    forwardRef,
    placeholder,
    helper,
    size,
    color,
    ...other
  } = props;
  return (
    <Grid size={{ lg, md, sm, xs }}>
      <FormControlLabel
        control={
          <Checkbox
            inputRef={(ref) => forwardRef && forwardRef(ref)}
            color={color || "primary"}
            checked={!!checked}
            onChange={(c, checked) => {
              return onChange && onChange(checked);
            }}
            //name="sn_controlled_value"
          />
        }
        label={label}
      />
    </Grid>
  );
};
